import { render, staticRenderFns } from "./SalonHome.vue?vue&type=template&id=579420ec&scoped=true"
import script from "./SalonHome.vue?vue&type=script&lang=js"
export * from "./SalonHome.vue?vue&type=script&lang=js"
import style0 from "./SalonHome.vue?vue&type=style&index=0&id=579420ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579420ec",
  null
  
)

export default component.exports